import React from 'react';
import _ from 'lodash';

import VaultApiRequestService from './VaultApiRequestService';
import { isResponseOkay } from './utils/miscFunctions';

export const SurveyContext = React.createContext();

// class wrapper for SurveyContext
class SurveyContextProvider extends React.Component {
    state = {
        activeSurveys: [],
        customers: [],
        lastLoaded: new Date(),
        totalActiveSurveys: 0,
        loading: true,
        loadingRest: true,
    }

    async componentDidMount() {
        await this.updateContext();
    }

    async updateContext() {
        await this.fetchAndUpdateCustomers();
        // set listener if active surveys does not exist or is empty
        if (!_.get(this.state, 'activeSurveys.length')) {
            await this.getActiveSurveys();
        }
    }

    // pulls customer data from database
    fetchAndUpdateCustomers = async () => {
        const response = await VaultApiRequestService.getCustomers();
        const customers = response?.data || [];
        if (this.state.activeSurveys && this.state.activeSurveys.length) {
            const activeSurveys = this.enrichTypeformSurveys(customers, this.state.activeSurveys);
            this.setState({
                activeSurveys,
                customers: customers
            });
        } else {
            this.setState({
                customers: customers
            });
        }
    return 
    };

    // gets first page (n=100) of surveys from the active workspace and sets the survey data to state
    // calls loadRest after setting state to load the remainder of the pages in the background
    getActiveSurveys = async () => {
        this.setState({ loading: true, lastLoaded: new Date() });
        const data = {
            page: 1,
            page_size: 100,
            workspace_id: process.env.REACT_APP_ACTIVE_WORKSPACE // current active workspace
        }
        const body = {
            body: JSON.stringify(data),
            method: 'POST'
        }
        let answer = await fetch(`/.netlify/functions/typeform?type=getAll`, body).then(response =>
            response.json()
        ).catch(err => console.log("Failed to fetch all forms: ", err));
        if (isResponseOkay(answer)) {
            const activeSurveys = this.enrichTypeformSurveys(this.state.customers, answer.message.items);
            this.setState({
                activeSurveys: [...activeSurveys],
                totalActiveSurveys: answer.message.total_items,
                loading: false
            }, ()=>{
                this.loadRest(answer.message.page_count);
            })
        } else {
            if (answer) {
                console.log(answer.status);
                console.log(answer.data);
            }
            this.setState({ loading: false });
        }
        console.log(answer);
    }

    // loads remainder of pages in the background after the first page loads
    loadRest = async (numPages) => {
        for (let index = 2; index <= numPages; index++) {
            const data = {
                page: index,
                page_size: 100,
                workspace_id: process.env.REACT_APP_ACTIVE_WORKSPACE // current active workspace
            }
            const body = {
                body: JSON.stringify(data),
                method: 'POST'
            }
            let answer = await fetch(`/.netlify/functions/typeform?type=getAll`, body).then(response =>
                response.json()
            ).catch(err => console.log("Failed to fetch all forms: ", err));
            if (isResponseOkay(answer)) {
                const newActiveSurveys = this.enrichTypeformSurveys(this.state.customers, answer.message.items);
                this.setState({
                    activeSurveys: [...this.state.activeSurveys, ...newActiveSurveys]
                });
            }
        }
        this.setState({ loadingRest: false });
    }

    // iterates through customers array and adds customer name and survey type to each active survey
    enrichTypeformSurveys = (customers, surveys) => {
        const newSurveys = [...surveys];
        customers.forEach(customer => {
            customer.campaigns.forEach(campaign => {
                campaign.surveys.forEach(survey => {
                    const surveyIndex = newSurveys.findIndex((e) => e.id === survey);
                    if(surveyIndex !== -1){
                        newSurveys[surveyIndex].customer = customer.name;
                        newSurveys[surveyIndex].campaignType = _.capitalize(campaign.type);
                    }
                })
            });
        });
        return newSurveys;
    }

    render() {
        return(
            <SurveyContext.Provider value={{
                ...this.state, 
                getActiveSurveys: this.getActiveSurveys,
                updateContext: this.updateContext,
                fetchAndUpdateCustomers: this.fetchAndUpdateCustomers
                }}>
                {this.props.children}
            </SurveyContext.Provider>
        )
    }
}

export const withSurveyContext = Component => props => (
    <SurveyContext.Consumer>
        {value => <Component surveyContext={{
                    activeSurveys: value.activeSurveys,
                    customers: value.customers,
                    lastLoaded: value.lastLoaded,
                    totalActiveSurveys: value.totalActiveSurveys,
                    loading: value.loading,
                    loadingRest: value.loadingRest, 
                    getActiveSurveys: value.getActiveSurveys,
                    fetchAndUpdateCustomers: value.fetchAndUpdateCustomers,
                    updateContext: value.updateContext,
                }} {...props}/>}
    </SurveyContext.Consumer>
)

export default SurveyContextProvider;

